import type { SubscriptionPeriodicity } from "../types/subscriptions"

export const subscriptionPrices: {
  [periodicity in SubscriptionPeriodicity]: number
} = {
  MONTHLY: 299 * 100,
  YEARLY: 2988 * 100,
}
